import TamboAI from "@tambo-ai/typescript-sdk";
import type { PartialDeep } from "type-fest";

export type PartialTamboAI = PartialDeep<TamboAI>;
